export default __webpack_public_path__ + "static/media/ico_whatsapp_white.5ee37a96.svg";